import { Component, input, InputSignal } from '@angular/core';
import { CardComponent } from '../../atoms/card/card/card.component';

@Component({
  selector: 'app-auth-template',
  templateUrl: './auth-template.component.html',
  imports: [CardComponent],
})
export class AuthTemplateComponent {
  public title: InputSignal<string> = input.required();
  public description: InputSignal<string> = input.required();
}
